import { Component, OnInit, OnDestroy, ChangeDetectorRef, AfterContentChecked, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

import { PdfService } from '../../../services/pdf/pdf.service';
import { MemberService } from '../../../services/member.service';
import { NavcontrolService } from '@app/services/navcontrol.service';
import { NewmemberService } from '@app/services/newmember/newmember.service';
import { MemberformService } from '@app/services/states/memberform/memberform.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';
import { Subscription, Observable, forkJoin } from 'rxjs';
import { CountryService } from '@app/services/shared/country.service';
import { Country } from '@app/models/country';
import { ClaimsService } from '@app/services/claims/claims.service';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { startWith, map } from 'rxjs/operators';
import { FileService } from '@app/services/files/file.service';
import { SnackbarService } from '@app/services/shared/snackbar.service';
import { AuthService } from '@app/services/auth/auth.service';
import { ConfirmationService, MenuItem, SelectItem } from 'primeng/api';
import { MembershipService } from '@app/services/membership.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SortService } from '@app/components/sorting/SortService';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CampaignService } from '@app/services/campaigns/campaign.service';
interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

interface Institution {
  id: number;
  shortName: string;
  name: string;
  noOfMembers: number;
}

@Component({
  selector: 'app-memberform',
  templateUrl: './memberform.component.html',
  styleUrls: ['./memberform.component.css']
})

export class MemberformComponent implements OnInit, OnDestroy, AfterContentChecked, OnChanges {
  primarylodgeformember: number;
  access;
  userpermissionlevel;
  userdomain;
  admininstitutionid;
  memberinstitutionslodge: any[] = [];
  memberinstitutionscamp: any[] = [];
  memberid;
  loggedinuserid;
  lodges: any[] = [];
  camps: any[] = [];
  memberaccess;
  userid;
  time;
  disable = false;
  action = 'not';
  id: number;
  viewmembersearch = false;
  imageToShow: any = null;
  photomissing = false;
  items: MenuItem[];
  memberdata;
  photodialog = false;
  // maxYear ska sättas dynamiskt.
  minmaxyear = { minYear: '1700', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?0789]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  subscriptions: Subscription[] = [];
  servicedbirthday;
  accordionstatus;
  memberoffices;
  permissions: string[] = [];

  fileData: File;
  previewUrl: any = null;
  fileUploadProgress: string = "";
  uploadedFilePath: string = "";
  uploadImage = false;
  result;
  addmembership = false;
  changeprimaryinstitution = false;
  terminatemembership = false;
  terminatemembershipcamp = false;
  terminatemembershipstorloge = false;
  imagewidth;
  imageheight;
  myControl = new FormControl('', Validators.required);

  data: LodgeAndCamp[] = [];
  filteredOptions: Observable<LodgeAndCamp[]>;
  selectedinstitution: any;
  selectedinstitutionname: string;
  selInst: number;

  institutionslist: SelectItem[] = [];
  institutionlist: Institution[] = [];
  countries: Country[] = [];
  selected;
 memberform;
  
  baseinfo: string;
  usualmember = false;
  ownmember = false;
  showall = false;
  institution;
  adminlodgeid: number;
  showconfirmation: boolean;
  isAdmin = false;
  isClerk = false;
  isSysAdmin = false;
  normalmember = false;

  currentuser;
  mobiledevice = false;
  test;
  useraccess;
  roleid;
  role;
hasMail = false;
  activerole;
  can_edit_member_baseinfo;
  can_change_password;
  can_view_memfee;
  can_edit_member_memberships;
  can_change_primaryinstitution;
  can_terminate_order_mermbership;
  can_end_camp_membership;
  view_membership_menu;
  view_matrix_card;

  foto;
  constructor(
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private sanitizer: DomSanitizer,
    private institutionService: InstitutionsService,
    private membershipService: MembershipService,
    private permissionsService: PermissionsService,
    private authService: AuthService,
    private _snackBar: MatSnackBar,
    private fileService: FileService,
    private institutionsService: InstitutionsService,
    private permissionService: PermissionsService,
    private claimsService: ClaimsService,
    private countryService: CountryService,
    private memberformService: MemberformService,
    private route: ActivatedRoute,
    private router: Router,
    private pdfservice: PdfService,
    private memberService: MemberService,
    private navcontrolService: NavcontrolService,
    private newmemberService: NewmemberService,
    private cdr: ChangeDetectorRef,
    private snackbarService: SnackbarService,
    private datePipe: DatePipe,
  private confirmationService: ConfirmationService,
private campaignService: CampaignService) {

  this.campaignService.getCampaignsForMember(this.route.snapshot.params['id']).subscribe((camps: any[]) => {  
        if (camps && camps.length > 0) {
          this.hasMail = true;
        }
      });

    this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    });

    this.permissionService.access.subscribe(y => {
      this.memberaccess = y;
    });

    this.loggedinuserid = this.claimsService.claims$.getValue()?.id;
    this.permissionService.userid = this.loggedinuserid;

    this.permissionsService.selectedrole.subscribe(x => {
      if (x) {
        this.role = x;
        this.roleid = x.roleId;
        this.access = x.permissions;
        this.userpermissionlevel = x.userPermissionLevel;
        if (this.userpermissionlevel === 'SY') {
          this.getAllInstitutions();
        }
        this.userdomain = x.userDomain;

        if (this.userpermissionlevel === 'IN' || this.userpermissionlevel === 'SY') {
          this.admininstitutionid = x.institution.id;
          this.permissionService.admininstitutionid = this.admininstitutionid;
        }
        this.setItems();
        if (this.memberid) {
          this.setPermissions(this.memberid);
          this.updateMemberInstitutions();

        }
      }
    });

    this.subscriptions.push(this.newmemberService.newbirthday.subscribe(data => {
      if(data) {
      this.servicedbirthday = data;
      this.memberform.get('member').get('birthday').setValue(data);
      }
    }));
  }

  getPrimarylodgeForMember(memberid) {
    this.memberService.getMemberPrimaryInstitution(memberid).subscribe(data => {
      if (data) {
        this.primarylodgeformember = data.id;
        this.setItems();
        this.updateMemberInstitutions();
      }
    });
  }

  async removePhoto() {
    this.confirmDialog()
  }

  removeMentor() {
    this.memberform.get('member').get('mentorMemberId').setValue(null);
    this.memberform.get('member').get('mentorName').setValue(null);
  }

  getMemberData(memberid) {
    this.memberService.getMemberById(memberid).subscribe(member => {
      this.memberdata = member;
      if (!this.memberdata.homeAddress) {
        this.memberdata.homeAddress = [];
      }
      if (!this.memberdata.workAddress) {
        this.memberdata.workAddress = [];
      }
      if (!this.memberdata.otherAddress) {
        this.memberdata.otherAddress = [];
      }
      this.memberdata.birthday = this.datePipe.transform(this.memberdata.birthday, 'yyyy-MM-dd');
      this.memberform.patchValue({
        member: member
      });
    });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  sanitize(url) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateMemberInstitutions;
    this.setItems();
  }

  updateAccordionStatus(field, expanded) {
    this.memberformService.memberformstate[field] = expanded;
    this.memberformService.accordionstatus.next(this.memberformService.memberformstate);
    this.memberformService.updateAccordions(this.accordionstatus);
  }

  toggleAllPanels(state) {
    this.memberformService.toggleAllPanels(state);
  }

  search() {
  }

  addMembership() {
    this.addmembership = true;
  }

  registerMember() {
    // Om det är sysadmin => anropa intrade
    // Om det är IN => anropa intrade/:id (admininstitutionid)
    if (this.userpermissionlevel === 'SY') {
      this.router.navigateByUrl('/intrade');
    } else {
      this.router.navigateByUrl('/intrade/' + this.admininstitutionid);
    }
  }

  changePrimaryInstitution() {
    this.changeprimaryinstitution = true;
  }

  changePrimaryInstitution1(evt) {
    this.changeprimaryinstitution = true;
  }

  terminateMembership() {
    this.terminatemembership = true;
  }

  terminateMembershipCamp() {
    this.terminatemembershipcamp = true;
  }

  terminateMembershipStorloge() {
    this.terminatemembershipstorloge = true;
  }

  changeMyPassword() {
    this.router.navigateByUrl('/changepassword/' + this.memberid);
  }

  changePasswordForMember() {
    this.router.navigateByUrl('/changepassword/' + this.memberid);
  }

  terminateMembership2(evt) {
    if (evt.institution.institutionTypeId === 4 ||
      evt.institution.institutionTypeId === 13 ||
      evt.institution.institutionTypeId === 10) {
      this.terminateMembership();
    } else if (evt.institution.institutionTypeId === 21) {
      this.selInst = evt.institution.id;
      this.terminateMembershipStorloge();
    } else {
      this.terminateMembershipCamp();
    }
  }

  ngOnInit() {
    this.userid = JSON.parse(sessionStorage.getItem('userid'));
    this.memberform = this.fb.group({
      institutionId: ['', ''], // Byt ut 4 mot ''. Institutions-idt får man via den inloggade användaren.
      initiatedDate: ['', ''],
      member: this.fb.group({
        id: ['', ''],
        localId: ['', ''],
        givenName: ['', Validators.required],
        otherForeNames: ['', ''],
        middleName: ['', ''],
        familyName: ['', Validators.required],
        formerName: ['', ''],
        title: ['', ''],
        homeAddress: this.fb.group({
          id: ['', ''],
          careOf: ['', ''],
          street: ['', Validators.required],
          zipCode: ['', ''],
          city: ['', Validators.required],
          country: ['', Validators.required]
        }),
        workAddress: this.fb.group({
          id: ['', ''],
          careOf: ['', ''],
          street: ['', ''],
          zipCode: ['', ''],
          city: ['', ''],
          country: ['', '']
        }),
        otherAddress: this.fb.group({
          id: ['', ''],
          careOf: ['', ''],
          street: ['', ''],
          zipCode: ['', ''],
          city: ['', ''],
          country: ['', '']
        }),
        phone: ['', ''],
        phone2: ['', ''],
        phoneWork: ['', ''],
        phoneMobile: ['', ''],
        fax: ['', ''],
        email: ['', Validators.email],
        email2: ['', Validators.email],
        webSite: ['', ''],
        exitDate: ['', ''],
        createdDate: ['', ''],
        changedDate: ['', ''],
        mentorMemberId: ['', ''],
        mentorName: ['', ''],
        birthday: ['', ''],
        isSubscriber: [true, '']
      })
    });
  
    this.permissionService.selectedrole.subscribe(r => {
      if(r) {
       this.setPermissions(this.memberid);
      }
    });
    this.activatedRoute.paramMap.subscribe(paramMap => {
      this.memberid = +paramMap.get('id');
      this.memberform.reset();
      if (this.memberid) {
        this.getPrimarylodgeForMember(this.memberid);
        //this.setPermissions(this.memberid);
        this.getMemberData(this.memberid);
      }
      
      this.action = paramMap.get('action');
      this.permissionService.memberid = this.memberid;
      this.action = paramMap.get('action');
      this.memberform.get('member').get('id').setValue(this.memberid);
 
      this.permissionService.memberid = this.memberid;
      this.lodges = [4, 13];
      this.camps = [5, 16];
      this.memberform.disable();
      this.disable = false;
      this.imageToShow = null;
      this.getImageFromService();
     
      this.memberformService.medid.next(this.memberid);
      
      this.ownmember = this.loggedInUsersMemberImage();
    });
    this.permissionsService.getActiveRole().subscribe(resp => {
      if (resp) {
        this.activerole = resp;
      }
    });

    this.memberService.timestamp.subscribe(t => {
      if (t) {
        this.id = this.permissionService.memberid;
        this.getImageFromService();
      }
    });

    this.claimsService.claims$.subscribe(item => {
      if(item) {
      if (item?.id === Number(this.route.snapshot.params?.id)) {
        this.currentuser = true;
      } else {
        this.currentuser = false;
      }
    }
    });

    this.updateMemberInstitutions();

    if (this.action === 'new') {
      this.memberform.get('member').get('homeAddress').get('country').setValue('Sverige');
    }

    const birth = this.route.queryParams['value'].birthday;
    if (birth) {
      this.memberform.get('member').get('birthday').setValue(birth);
    }

    // Om man skapar ny medlem ska initialiseringsdatum finnas med i formuläret. När man tittar på en befintlig medlem
    // sätts ett default-datum för att formuläret ska bli valid. Fältet visas inte i detta fallet.
    if (this.action !== 'new') {
      this.memberform.get('initiatedDate').setValue('1800-01-01');
    }

    if (this.route.queryParams['value'].institutionid) {
      this.getInstitution(Number(this.route.queryParams['value'].institutionid));
      this.memberform.get('institutionId').setValue(this.route.queryParams['value'].institutionid);
    }

    this.subscriptions.push(this.memberformService.mentorsearch.subscribe(data => {
      this.viewmembersearch = false;
    }));

    this.countries = this.countryService.getCountryList();

    // Hämta födelsedatum för ny medlem.
    this.servicedbirthday = this.newmemberService.birthday;
    // Sök institutionsid när man är kanslist eller loge-admin.
    if (this.isClerk || this.isSysAdmin) {
      this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(data => {
        data.forEach(element => {
          const inst = { id: element.id, shortName: element.shortName, name: element.name };
          this.data.push(inst);
        });

        this.filteredOptions = this.myControl.valueChanges
          .pipe(
            startWith<string | LodgeAndCamp>(''),
            map(value => typeof value === 'string' ? value : value.name),
            map(name => name ? this._filter(name) : this.data.slice())
          );
        /* end autocomplete */
      }));
    }

    // Permissions hämtas och sätts i app.component.ts ?????
    this.permissionService.permissions.subscribe(response => {
      if (response) {
        const idxnormalmember = this.permissions.findIndex(item => {
          return item === 'NORMAL_MEMBER';
        });
        this.normalmember = idxnormalmember !== -1 ? true : false;
      }
    });

    // PRENUMERERA PÅ ACCORDIONSTATUS FRÅN MEMBERFORMSERVICE
    this.subscriptions.push(this.memberformService.accordionstatus.subscribe(value => {
      this.accordionstatus = value;
    }));

    if (!this.memberid) {
      this.memberformService.resetMemberformState();
      this.disableForm(false);
    } else {
      this.memberform.disable();
    }

    this.updateMemberInstitutions();
    this.permissionService.access.subscribe(a => {
      if (a) {
        this.useraccess = a;
      }
    });
  }

  // Är det inloggad användares medlemsbild som användaren tittar på
  loggedInUsersMemberImage() {
    return this.memberid === this.claimsService.getActualMemberId() ? true : false;
  }

  getInstitution(institutionid: number) {
    this.institutionsService.getInstitutionByIdAsync(institutionid).subscribe(i => {
      this.institution = i;
    });
  }

  updateMemberInstitutions() {
    this.memberinstitutionslodge = [];
    this.memberinstitutionscamp = [];
    if (this.route.snapshot.params.id) {
      this.membershipService.getMembershipByMemberId(Number(this.route.snapshot.params.id)).subscribe(memship => {
        memship?.forEach(m => {
          if ((m.endDate).indexOf('9999-12-31') !== -1) {
            if (this.lodges.indexOf(m.institution.institutionTypeId) !== -1) {
              this.memberinstitutionslodge.push(m.institution.id);
              this.permissionService.memberlodge = m.institution.id;
            }
            if (this.camps.indexOf(m.institution.institutionTypeId) !== -1) {
              this.memberinstitutionscamp.push(m.institution.id);
              this.permissionService.membercamp = m.institution.id;
            }
          }
        });
        this.permissionService.memberid = this.memberid;
        this.permissionService.setMemberAccess();
      });
    }
  }

  setPermissions(memberid: number) {
    
     const user_permissions = JSON.parse(sessionStorage.getItem('selectedrole'))?.permissions;
  
     if(user_permissions) {
    this.can_edit_member_baseinfo = user_permissions.indexOf('EDIT_MEMBER_BASEINFO') !== -1;
    this.can_change_password = user_permissions.indexOf('CHANGE_PASSWORD') !== -1;
    this.can_view_memfee = (this.memberid === +this.userid || user_permissions.indexOf('VIEW_MEMFEE') !== -1) ? true : false;
    this.can_edit_member_memberships = user_permissions.indexOf('EDIT_MEMBER_MEMBERSHIPS') !== -1;
    this.can_change_primaryinstitution = user_permissions.indexOf('CHANGE_PRIMARY_INSTITUTION') !== -1;
    this.can_terminate_order_mermbership = user_permissions.indexOf('TERMINATE_ORDER_MEMBERSHIP') !== -1;
    this.can_end_camp_membership = user_permissions.indexOf('END_CAMP_MEMBERSHIP') !== -1;
    this.view_matrix_card = user_permissions.indexOf('VIEW_MATRIX_CARD') !== -1;
    this.setItems();
     }
    /*let can_edit_member_baseinfo_observable = this.permissionsService.hasPermissionForMember('EDIT_MEMBER_BASEINFO', memberid);
    let can_change_members_password_observable = this.permissionsService.hasPermissionForMember('CHANGE_PASSWORD', memberid);
    let can_view_memfee_observable = this.permissionsService.hasPermissionForMember('VIEW_MEMFEE', memberid);
    let can_edit_member_memberships_observable = this.permissionsService.hasPermissionForMember('EDIT_MEMBER_MEMBERSHIPS', memberid);
    let can_change_primary_institution_observable = this.permissionsService.hasPermissionForMember('CHANGE_PRIMARY_INSTITUTION', memberid);
    let can_terminate_order_membership_observable = this.permissionsService.hasPermissionForMember('TERMINATE_ORDER_MEMBERSHIP', memberid);
    let can_end_camp_membership_observable = this.permissionsService.hasPermissionForMember('END_CAMP_MEMBERSHIP', memberid);
    let view_matrix_card = this.permissionService.hasPermissionForMember('VIEW_MATRIX_CARD', memberid);
    this.subscriptions.push(forkJoin([
      can_edit_member_baseinfo_observable,
      can_change_members_password_observable,
      can_view_memfee_observable,
      can_edit_member_memberships_observable,
      can_change_primary_institution_observable,
      can_terminate_order_membership_observable,
      can_end_camp_membership_observable,
      view_matrix_card
    ]).subscribe(response => {
      this.can_edit_member_baseinfo = response[0];
      this.can_change_password = response[1];
      this.can_view_memfee = (this.memberid === +this.userid || response[2] === true) ? true : false;
      this.can_edit_member_memberships = response[3];
      this.can_change_primaryinstitution = response[4];
      this.can_terminate_order_mermbership = response[5];
      this.can_end_camp_membership = response[6];
      this.view_matrix_card = response[7];
      
    }));*/
  }

  setItems() {
    this.items = [
      {
        label: 'Medlemskap',
        items: [{
          label: 'Byt primärinstitution',
          icon: 'fa fa-exchange',
          command: () => this.changePrimaryInstitution(),
          // tslint:disable-next-line: max-line-length
          visible: this.can_change_primaryinstitution
        }, {
          label: 'Avsluta medlemskap',
          icon: 'fa fa-user-times',
          command: () => this.terminateMembership(),
          // tslint:disable-next-line: max-line-length
          visible: this.can_terminate_order_mermbership
        }, {
          label: 'Avsluta medlemskap i läger',
          icon: 'fa fa-user-times',
          command: () => this.terminateMembershipCamp(),
          // tslint:disable-next-line: max-line-length
          visible: this.can_end_camp_membership
        },
        {
          label: 'Avsluta medlemskap i Storlogen',
          icon: 'fa fa-user-times',
          command: () => this.terminateMembershipStorloge(),
          // tslint:disable-next-line: max-line-length
          visible: this.can_end_camp_membership
        }]
      }
    ];
    let antal = 0;
    this.items[0].items.forEach(i => {
      if (i.visible) {
        antal++;
      }
    });
    if (antal !== 0) {
      antal > 0 ? this.view_membership_menu = true : this.view_membership_menu = false;
    }
  }


  get localId() {
    return this.memberform.get('member').get('localId');
  }
  get givenName() {
    return this.memberform.get('member').get('givenName');
  }

  get middleName() {
    return this.memberform.get('member').get('middleName');
  }

  get familyName() {
    return this.memberform.get('member').get('familyName');
  }

  get formerName() {
    return this.memberform.get('member').get('formerName');
  }

  get title() {
    return this.memberform.get('member').get('title');
  }

  get homeAddress_street() {
    return this.memberform.get('member').get('homeAddress').get('street');
  }

  get homeAddress_zipCode() {
    return this.memberform.get('member').get('homeAddress').get('zipCode');
  }

  get homeAddress_city() {
    return this.memberform.get('member').get('homeAddress').get('city');
  }


  get homeAddress_country() {
    return this.memberform.get('member').get('homeAddress').get('country');
  }

  get workAddress_street() {
    return this.memberform.get('member').get('workAddress').get('street');
  }

  get workAddress_country() {
    return this.memberform.get('member').get('workAddress').get('country');
  }

  get otherAddress_street() {
    return this.memberform.get('member').get('otherAddress').get('street');
  }

  get otherAddress_country() {
    return this.memberform.get('member').get('otherAddress').get('country');
  }

  get phone() {
    return this.memberform.get('member').get('phone');
  }

  get phone2() {
    return this.memberform.get('member').get('phone2');
  }

  get phoneMobile() {
    return this.memberform.get('member').get('phoneMobile');
  }

  get email() {
    return this.memberform.get('member').get('email');
  }

  get email2() {
    return this.memberform.get('member').get('email2');
  }

  get birthday() {

    return this.datePipe.transform(this.memberform.get('member').get('birthday'), 'yyyy-MM-dd');
  }

  disableForm(dis) {
    this.disable = !dis;
    this.disable ? this.memberform.enable() : this.memberform.disable();
  }

  saveForm() {
    if (this.memberform.get('member').get('id').value !== '') {
      this.memberform.markAsPristine();
      this.disable = true;
      this.disableForm(true);
      if (this.memberaccess.role.permissions.indexOf('EDIT_MEMBER_BASEINFO') > -1) {
        this.subscriptions.push(this.memberService.updateMember(this.memberform.get('member').value as any).subscribe(data => {
          if (data) {
            this._snackBar.open('Ändringar sparade.', null, { duration: 3000 });
          }
          this.router.navigate(['/memberform/id/', this.memberform.get('member').get('id').value]);
        }));
      } else {
        this.subscriptions.push(this.memberService.updateMemberWithoutAccess(this.memberform.get('member').value as any).subscribe(data => {
          if (data) {
            this._snackBar.open('Ändringar sparade.', null, { duration: 3000 });
          }
          this.router.navigate(['/memberform/id/', this.memberform.get('member').get('id').value]);
        }));
      }
    } else {
      this.subscriptions.push(this.memberService.addMember(this.memberform.value).subscribe(data => {
        if (data) {
          const memberdata = {
            givenName: this.memberform.get('member').get('givenName').value,
            familyName: this.memberform.get('member').get('familyName').value,
            memberId: data.body.memberid,
            password: data.body.generatedPassword,
            primaryInstitution: this.selectedinstitutionname
          };
          this.memberService.newmemberdata.next(memberdata);
          this.router.navigate(['/kontoinformation']);
        }
      }));
    }
  }

  cancel() {
    if (this.memberform.dirty) {
       this.confirmationService.confirm({
      header: 'Bekräftelse',
      message: 'Vill du avbryta utan att spara ändringarna?',
      acceptLabel: 'Ja',
      rejectLabel: 'Nej',
      accept: () => {
         if (this.action !== 'new') {
            this.router.navigate([], {
              skipLocationChange: true,
              queryParams: { id: this.memberid },
              queryParamsHandling: 'merge' //== if you need to keep queryParams
            });
            this.ngOnInit();
            this.disableForm(true);
            this.memberform.markAsPristine();
          } else {
            this.memberform.reset();
            this.router.navigate(['']);
          }
      },
      reject: () => {
      }
    });
    } else {
      if (this.action === 'new') {
        this.memberform.reset();
        this.router.navigate(['']);
      } else {
        this.disableForm(true);
        this.router.navigate([], {
          skipLocationChange: true,
          queryParams: { id: this.memberid },
          queryParamsHandling: 'merge' //== if you need to keep queryParams
        });
      }
    }
  }

  onSubmit() {
  }

  clear() {
    this.myControl.setValue(null);
  }

  captureScreen() {
    const data = document.getElementById('contentToConvert');
    this.pdfservice.captureScreen(data, 'l', null);
  }

  quitMembership() {
    this.router.navigate(['/avslutamedlemskaploge']);
  }

  viewSentMails() {
    this.router.navigate(['/sentmails/id/', this.memberid]);
  }

  viewFailedMails() {
    this.router.navigate(['/allfailedmails']);
  }

  updateNavControl() {
    this.navcontrolService.updateNavControl();
  }

  // Öppna sökfönster för att söka fram mentor till medlemsformuläret
  searchMentor() {
    this.viewmembersearch = true;
  }

  // Hantera val av mentor från sökfönstret
  mentorSelected1(event) {
    if (!event) {
    } else if (event === 'nomemberchoosen') {
    } else if (event === 'cancelselectmember') {
    } else {
      this.memberform.get('member').get('mentorMemberId').setValue(event.id);
      this.memberform.get('member').get('mentorName').setValue(event.givenName + ' ' + event.familyName);
      this.memberform.markAsDirty();
    }
    this.viewmembersearch = false;
  }

  private _filter(name: string): LodgeAndCamp[] {
    const filterValue = name.toLowerCase();
    // tslint:disable-next-line:max-line-length
    return this.data.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1 || option.shortName.toLowerCase().indexOf(filterValue) !== -1);
  }

  displayFn(user?: LodgeAndCamp): string | undefined {
    return user ? user.shortName + ' ' + user.name : undefined;
  }

  onSelectionChanged(event: MatAutocompleteSelectedEvent) {
    this.selectedinstitution = event.option.value.id;
    this.memberform.get('institutionId').setValue(event.option.value.id);
    this.selectedinstitutionname = event.option.value.shortName + ' ' + event.option.value.name;
  }

  getImageFromService() {
    this.previewUrl = null;
    if (this.action !== 'new') {
      this.memberService.GetMemberImageThumbnail(this.memberid).subscribe(data => {      
        this.createImageFromBlob(data);
      }, error => {
        this.imageToShow = null;
      });
    }
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageToShow = reader.result;
      if (this.imageToShow) {
        this.getSize(this.imageToShow);
      }
    }, false);

    if (image) { 
      reader.readAsDataURL(image);
    }
  }

  getSize(imgdata) {
    const image = document.createElement('img');
    const self = this;
    image.addEventListener('load', function () {
      self.imagewidth = image.width;
      self.imageheight = image.height;
    });
    image.src = imgdata;
    this.previewUrl = imgdata;
  }

  viewMentor() {
    this.router.navigate(['/memberform/id/', this.memberform.get('member').get('mentorMemberId').value]);
  }

  viewMatrix() {
    this.router.navigate(['/matrix_report/id/', this.memberid]);
  }

  fileProgress(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
    this.getSize(this.fileData);
    this.preview();
  }

  preview() {
    const mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
      
    };
  }

  saveMemberImage() {
    const formData = new FormData();
    formData.append('uploadedFile', this.fileData);
    formData.append('originatingId', this.memberid.toString());
    this.fileService.UploadMemberImage(formData).subscribe(response => {
      if (response) {
        this.previewUrl = null;
        this.uploadImage = false;
        this.snackbarService.openSnackBar('Fotot inlagt.', null);
        this.ngOnInit();
      }
    });
  }

  cancelImageUpload() {
    this.uploadImage = false;
    this.previewUrl = null;
  }



async confirmDialog() {
    this.confirmationService.confirm({
            header: 'Radera?',
            message: 'Vill du radera det uppladdade fotot?',
            icon: 'pi pi-exclamation-circle',
            rejectButtonProps: {
                label: 'Nej',
                icon: 'fa fa-times',
                variant: 'outlined',
                size: 'small'
            },
            acceptButtonProps: {
                label: 'Ja',
                icon: 'fa fa-check',
                size: 'small'
            },
            accept: async () => {
        const res: Response = await fetch('../../../assets/bildsaknas.jpg');
        const blob: Blob = await res.blob();
        const file = new File([blob], this.memberid + '.jpg', { type: 'image/jpeg' });
        const formData = new FormData();
        formData.append('uploadedFile', file);
        formData.append('originatingId', this.memberid);
        this.fileService.UploadMemberImage(formData).subscribe(response => {
          if (response) {
            this.snackbarService.openSnackBar('Fotot raderat', null);
            this.memberService.timestamp.next(new Date());
            this.router.navigateByUrl('/memberform/id/' + this.memberid);
          }
        });       
                
            },
            reject: () => {
                
            }
        });
}

  closeAdd(evt: any) {
    this.addmembership = false;
  }

  closeChange(evt: any) {
    this.changeprimaryinstitution = false;
    this.time = new Date();
    this.updateAccordionStatus('actualmembership', true)
  }

  closeTerminate(evt: any) {
    this.terminatemembership = false;
    this.router.navigate(['/memberform/id/', this.memberid]);
    this.time = Math.floor(Math.random() * 1000000) + 1;
  }

  closeTerminateCamp(evt: any) {
    this.terminatemembershipcamp = false;
    this.time = Math.floor(Math.random() * 1000000) + 1;
  }

  closeTerminateStorloge(evt: any) {
    this.terminatemembershipstorloge = false;
    this.time = Math.floor(Math.random() * 1000000) + 1;
  }

  deleteMemberImage() {
    this.confirmDialog();
  }

  getAllInstitutions() {
    this.institutionService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutionlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.institutionlist = this.institutionlist.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
      const removelist = ['AV1', 'AVGBREV1', 'UT1', 'EL', 'ELA', 'K', 'RLK1', 'RR1', 'SOFT1', 'SOFT2', 'SL1', 'SGL1'];
      this.institutionlist = this.institutionlist.filter(x => {
        return removelist.indexOf(x.shortName) === -1;
      });

      this.institutionlist.forEach(c => {
        this.institutionslist.push({ label: c.name, value: c.id });
      });
    });
  }
  setInstitution() {
    this.memberform.patchValue({ institutionId: this.selectedinstitution });
  }
}
